import React from 'react'
import { Layout } from 'antd'
import './index.less'

const { Footer } = Layout

class CustomisedFooter extends React.Component {
  render() {
    return (
      <Footer className='app-footer'>
        Powered by Next In Line Inc &trade;
      </Footer>
    )
  }
}

export default CustomisedFooter


// WEBPACK FOOTER //
// ./src/components/elements/AppFooter/index.jsx